import { TypeBlock } from '@/API/user';
import request from '@/services/request';
import getError from '@/services/getError';
/**
 * @param {'PAID_INTERNSHIP' , 'PAID_POSTGRADUATE' , 'PAID_ASSIST' , 'PAID_BSM' , 'INTERNSHIP' , 'POSTGRADUATE' , 'DOP_MAG' , 'BSMA'} typeBlock
 * @param {id, null, undefined} id orgId
 * @return {Promise<Array>}
 * */
// eslint-disable-next-line no-unused-vars
// export async function getOrgTableDataWithType(typeBlock, id,) {
//   let year = '2023';
//   try {
//     if (store.getters.selectedYear) year = store.getters.selectedYear;
//     if (store.getters['keycloak/getUser']?.orgID) id = store.getters['keycloak/getUser']?.orgID;
//     if (store.getters['keycloak/getFakeUser']) id = store.getters['keycloak/getFakeUser']?.id;

//     if (!TypeBlock.includes(typeBlock)) throw new Error(`typeBlock doesn't exist in allow values`);

//     const res = await request({
//       endpoint: `/api/${year}/data/kcptables/${id}/${typeBlock}`,
//       method: 'get',
//     });
//     if (res.status === 200) {
//       return res.data;
//     }
//   } catch (e) {
//     await store.dispatch(
//       'notifications/setNotification',
//       {
//         notificationStatus: 'error',
//         notificationMessage: 'Ошибка получения данных ',
//         timeout: 3000,
//       },
//       { root: true },
//     );
//     throw new Error(`error getOrgTableDataWithType ${typeBlock}` + e);
//   }
// }
export async function getOrgTableDataWithType(orgId, typeBlock, year) {
  try {
    if (!TypeBlock.includes(typeBlock)) throw new Error(`typeBlock doesn't exist in allow values`);

    const res = await request({
      endpoint: `/api/${year}/data/kcptables/${orgId}/${typeBlock}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error getOrgTableDataWithType ${typeBlock}` + e);
  }
}
// export async function changeOrgTableDataWithType(row) {
//   let year = '2023';
//   try {
//     if (store.getters.selectedYear) year = store.getters.selectedYear;
//     const res = await request({
//       endpoint: `/api/${year}/data/kcptables`,
//       method: 'post',
//       body: row,
//     });
//     if (res.status === 200) {
//       return res.data;
//     }
//   } catch (e) {
//     await store.dispatch(
//       'notifications/setNotification',
//       {
//         notificationStatus: 'error',
//         notificationMessage: 'Ошибка сохранения данных ',
//         timeout: 3000,
//       },
//       { root: true },
//     );
//     throw new Error(`error changeOrgTableDataWithType ` + e);
//   }
// }
export async function changeOrgTableDataWithType(row, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/kcptables`,
      method: 'post',
      body: row,
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error changeOrgTableDataWithType ` + e);
  }
}
export async function deleteOrgTableDataWithType(id, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/kcptables/${id}`,
      method: 'delete',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error deleteOrgTableDataWithType ` + e);
  }
}
